"use client";
import {Button} from "@/components/ui/button";
import Title from "@/components/site/Title";
import {useState} from "react";
import axios from "axios";
import toast from "react-hot-toast";

export default function NewsletterForm(){
    const [email, setEmail] = useState("");
    const handleSubmit = async e =>{
        e.preventDefault();

        axios.post("/api/newsletter", {email})
            .then(res => toast.success("Félicitation vous êtes maintenant abonné"))
            .catch(err => toast.error("Une erreur s'est produite"));
    }
    return(
        <section className={"py-10 px-5 md:px-0"}>
            <Title content={"Newsletter"} hilight={"CWF-Coworkfit"}/>
            <form className={"flex flex-col justify-center items-center py-5 w-full gap-y-5"} onSubmit={handleSubmit}>
                <input type={"email"} placeholder={"Email"} required className={"border-primary rounded w-full lg:w-1/3 placeholder:text-primary"} onChange={e => setEmail(e.target.value)}/>
                <Button className={"text-white"}>Je m&apos;abonne</Button>
            </form>
        </section>
    )
}